import { render, staticRenderFns } from "./PollAnswer.vue?vue&type=template&id=af3bb946&lang=pug&"
import script from "./PollAnswer.vue?vue&type=script&lang=ts&"
export * from "./PollAnswer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports